import { type QueryKey, useQuery } from 'react-query'

import { type RepoPaginatedResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginatedResponse'
import { type ListCatalogConfigData } from '@webapp/modules/purchasing/business-logic/types/ListCatalogConfigData'
import { type CatalogPermissionUserConfigConstructor } from '@webapp/modules/purchasing/entities/CatalogPermissionUserConfig'
import { catalogAccessQueryConfig } from '@webapp/modules/purchasing/query-configs/catalogAccess'

type UseListCatalogPermissionUserConfigsModelReturn = {
  data:
    | RepoPaginatedResponse<CatalogPermissionUserConfigConstructor>
    | undefined
  isLoading: boolean
  error: Error | null
  queryKey: QueryKey
}

export const useListCatalogPermissionUserConfigsModel = (
  params: ListCatalogConfigData
): UseListCatalogPermissionUserConfigsModelReturn => {
  const queryConfig = catalogAccessQueryConfig.userConfigs(params)

  const { data, isLoading, error } = useQuery<
    RepoPaginatedResponse<CatalogPermissionUserConfigConstructor>,
    Error
  >(queryConfig)

  return {
    data,
    isLoading,
    error: error ?? null,
    queryKey: queryConfig.queryKey,
  }
}
